 <app-breadcrumb currentPage="Pricing"></app-breadcrumb>
<section id="pricing" class="pricing section">

  <div class="container section-title" data-aos="fade-up">
    <h2 class="text-center">
      Flexible solutions designed to help your business build, innovate, and grow
    </h2>
    <p>Whether you need a professional business website, a growing digital presence, or a custom software solution, we
      offer clear starting prices with flexible options based on your requirements.</p>
    <div class="service-list">
      <span>Simple Scope</span>
      <span>Clearing Pricing</span>
      <span>No Unnecessary Complexity</span>
    </div>
  </div>

  <div class="container" data-aos="fade-up" data-aos-delay="100">
    <div class="row gy-4 justify-content-center">

      <!-- Starter Plan -->
      <div class="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-delay="100">
        <div class="pricing-card">
          <div class="pricing-header">
            <span class="plan-label">STARTER</span>
            <!-- <h3>Starter Plan</h3> -->
            <h3>Professional Website</h3>
            <p class="plan-description">
              Perfect for individuals, startups, and small businesses looking to establish a professional online
              presence.
            </p>
            <div class="price">
              <span class="currency">$</span>
              <span class="amount">500</span>
              <span class="period">/ Project</span>
            </div>
          </div>

          <div class="pricing-divider"></div>

          <ul class="features">
            <li><i class="bi bi-check-circle-fill"></i><span>Responsive Website Design</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Up to 5 Pages</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Mobile &amp; Tablet Friendly</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Contact Form Integration</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Basic SEO</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Social Media</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Analytics Setup</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Website deployment</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>30 Days Supportt</span></li>
          </ul>

          <div class="pricing-footer">
            <a href="#contact" class="pricing-btn">
              Get Started <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Professional Plan -->
      <div class="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-delay="200">
        <div class="pricing-card featured">
          <div class="popular-badge">Most Popular</div>

          <div class="pricing-header">
            <span class="plan-label">BUSINESS</span>
            <h3>Business Website & Growth</h3>
            <p class="plan-description">
              Ideal for growing businesses that need a powerful website with enhanced functionality and digital integrations.
            </p>
            <div class="price">
              <span class="currency">$</span>
              <span class="amount">1599</span>
              <span class="period">/ Project</span>
            </div>
          </div>

          <div class="pricing-divider"></div>

          <ul class="features">
            <li><i class="bi bi-check-circle-fill"></i><span>Everything in Starter</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Up to 10 Pages</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Custom UI/UX Design</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Advanced Forms</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>SEO Optimization</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Analytics & Tracking</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Third-Party Integrations</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Performance Optimization</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>90 Days Support</span></li>
          </ul>

          <div class="pricing-footer">
            <a href="#contact" class="pricing-btn primary">
              Choose Plan <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Enterprise Plan -->
      <div class="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-delay="300">
        <div class="pricing-card">
          <div class="pricing-header">
            <span class="plan-label">CUSTOM</span>
            <h3>Custom Digital Solution</h3>
            <p class="plan-description">
              For businesses that need custom applications, SaaS platforms, integrations, or software solutions beyond a
              standard website.
            </p>
            <div class="price custom-price">
              <span class="custom-text">Let's Talk</span>
            </div>
          </div>

          <div class="pricing-divider"></div>

          <ul class="features">
            <li><i class="bi bi-check-circle-fill"></i><span>Custom Web Applications</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Software & Product Development</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>SaaS Application Development</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Angular / React Development</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Custom UI/UX Solutions</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>REST API Integration</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Database Integration</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Cloud Integrations</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Application Maintenance</span></li>
            <li><i class="bi bi-check-circle-fill"></i><span>Technical support</span></li>
          </ul>

          <div class="pricing-footer">
            <a href="#contact" class="pricing-btn">
              Request a Quote <i class="bi bi-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>

    </div>

    <!-- ============================================================
         Information Accordions
         ============================================================ -->

    <div class="pricing-accordions">

      <!-- Support & Maintenance -->
      <details class="pricing-accordion">
        <summary>
          <span class="accordion-title">SUPPORT &amp; MAINTENANCE</span>
          <span class="accordion-icon" aria-hidden="true">
            <i class="bi bi-plus"></i>
          </span>
        </summary>

        <div class="accordion-content">
          <p class="accordion-intro">Already have a website or application?</p>
          <p>We can help you maintain, improve, and support your existing digital products.</p>

          <p class="accordion-subtitle">Support Services</p>

          <ul class="accordion-list">
            <li><i class="bi bi-check2-circle"></i> Website maintenance</li>
            <li><i class="bi bi-check2-circle"></i> Application support</li>
            <li><i class="bi bi-check2-circle"></i> Bug fixes &amp; issue resolution</li>
            <li><i class="bi bi-check2-circle"></i> Security &amp; dependency updates</li>
            <li><i class="bi bi-check2-circle"></i> Performance improvements</li>
            <li><i class="bi bi-check2-circle"></i> Content &amp; configuration updates</li>
            <li><i class="bi bi-check2-circle"></i> Feature enhancements</li>
            <li><i class="bi bi-check2-circle"></i> Production troubleshooting</li>
            <li><i class="bi bi-check2-circle"></i> Continuous application maintenance</li>
          </ul>

          <p class="accordion-pricing"><strong>Pricing:</strong> Custom</p>
          <p class="accordion-note">
            Support requirements vary depending on the application, technology,
            complexity, and level of support required.
          </p>
        </div>
      </details>

      <!-- What's Included -->
      <details class="pricing-accordion">
        <summary>
          <span class="accordion-title">WHAT'S INCLUDED IN EVERY PROJECT?</span>
          <span class="accordion-icon" aria-hidden="true">
            <i class="bi bi-plus"></i>
          </span>
        </summary>

        <div class="accordion-content">
          <p class="accordion-intro">
            We believe good development starts with clear communication and well-defined requirements.
          </p>
          <p>Depending on the selected package, our project process can include:</p>

          <ul class="accordion-list accordion-process-list">
            <li>
              <i class="bi bi-check2-circle"></i>
              <div>
                <strong>Requirement Discussion</strong>
                <p>Understand your business, goals, users, and technical requirements.</p>
              </div>
            </li>
            <li>
              <i class="bi bi-check2-circle"></i>
              <div>
                <strong>Design &amp; Development</strong>
                <p>Build a responsive and maintainable digital solution based on the agreed scope.</p>
              </div>
            </li>
            <li>
              <i class="bi bi-check2-circle"></i>
              <div>
                <strong>Testing &amp; Quality Checks</strong>
                <p>Validate functionality, responsiveness, and key user journeys before delivery.</p>
              </div>
            </li>
            <li>
              <i class="bi bi-check2-circle"></i>
              <div>
                <strong>Deployment Assistance</strong>
                <p>Assist with publishing the website or application to the agreed environment.</p>
              </div>
            </li>
            <li>
              <i class="bi bi-check2-circle"></i>
              <div>
                <strong>Post-Launch Support</strong>
                <p>Provide support for the period included in your selected package.</p>
              </div>
            </li>
            <li>
              <i class="bi bi-check2-circle"></i>
              <div>
                <strong>Continuous Improvement</strong>
                <p>Additional features, enhancements, and ongoing maintenance can be handled through a separate agreement.</p>
              </div>
            </li>
          </ul>
        </div>
      </details>

      <!-- Clear Scope -->
      <details class="pricing-accordion">
        <summary>
          <span class="accordion-title">CLEAR SCOPE. CLEAR EXPECTATIONS.</span>
          <span class="accordion-icon" aria-hidden="true">
            <i class="bi bi-plus"></i>
          </span>
        </summary>

        <div class="accordion-content">
          <p class="accordion-intro">Your project should have no surprises.</p>

          <p>
            Our pricing is based on the agreed scope and requirements. Before development begins,
            we discuss the expected features, deliverables, timelines, and responsibilities.
          </p>

          <p class="accordion-highlight">
            Pricing shown is a starting price and applies to the features and scope described in each package.
          </p>

          <p class="accordion-subtitle">
            The following may be quoted separately where applicable:
          </p>

          <ul class="accordion-list">
            <li><i class="bi bi-check2-circle"></i> Domain registration</li>
            <li><i class="bi bi-check2-circle"></i> Hosting / cloud infrastructure</li>
            <li><i class="bi bi-check2-circle"></i> Premium themes, plugins, or software licenses</li>
            <li><i class="bi bi-check2-circle"></i> Paid third-party services</li>
            <li><i class="bi bi-check2-circle"></i> Advanced integrations</li>
            <li><i class="bi bi-check2-circle"></i> Content creation</li>
            <li><i class="bi bi-check2-circle"></i> Additional pages</li>
            <li><i class="bi bi-check2-circle"></i> Additional features or functionality</li>
            <li><i class="bi bi-check2-circle"></i> Major changes outside the agreed scope</li>
            <li><i class="bi bi-check2-circle"></i> Ongoing maintenance and support</li>
          </ul>

          <p class="accordion-note">
            Final pricing is confirmed after requirements and scope are agreed.
          </p>
        </div>
      </details>

    </div>

  </div>
</section>

<section class="cta-section">
  <div class="container cta-inner">
    <div><span class="eyebrow">HAVE A PROJECT IN MIND?</span>
      <h2>Let's Build Something That Works for Your Business.</h2>
      <p>Tell us what you're looking to build, improve, or maintain. We'll understand your requirements and recommend a
        solution based on your goals and scope.
      </p>
    </div>
    <a routerLink="/contactus" class="btn-primary-red">Get Started <i class="bi bi-arrow-right ms-2"></i></a>
  </div>
</section>